import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function J() {
    const { useLang, Link } = useGlobal();
    const { t } = useLang('camp');
    const lists: any[] = [
        {
            img: '/responsive/picture/camp/10_1.jpg',
            title: t('secJ_list1_title'),
            desc: t('secJ_list1_desc'),
        },
        {
            img: '/responsive/picture/camp/10_2.jpg',
            title: t('secJ_list2_title'),
            desc: t('secJ_list2_desc'),
        },
        {
            img: '/responsive/picture/camp/10_3.jpg',
            title: t('secJ_list3_title'),
            desc: t('secJ_list3_desc'),
        },
        {
            img: '/responsive/picture/camp/10_4.jpg',
            title: t('secJ_list4_title'),
            desc: t('secJ_list4_desc'),
        },
    ];

    const links: any[] = [
        {
            link: t('secJ_link1'),
            text: t('secJ_link1_text'),
        },
        {
            link: t('secJ_link2'),
            text: t('secJ_link2_text'),
        },
        {
            link: t('secJ_link3'),
            text: t('secJ_link3_text'),
        },
    ];

    return (
        <div id="camp-J" className={`camp-J camp-box ${css['camp-J']}`}>
            <h2 className="title">{t('secJ_title')}</h2>
            <div className="img-box">
                <EFPicture src={'/responsive/picture/camp/10.jpg'} alt={t('secJ_title')} />
            </div>
            <p className="desc">{t('secJ_desc')}</p>
            <ul className="lists">
                {lists?.map((list: any, k: number) => (
                    <li className="list" key={k}>
                        <h3 className="list-title">{list?.title}</h3>
                        <div className="list-info">
                            <div className="list-img">
                                <EFPicture src={list?.img} alt={list?.title} />
                            </div>
                            <p className="list-desc desc">{list?.desc}</p>
                        </div>
                    </li>
                ))}
            </ul>
            <p className="desc memo">{t('secJ_text')}</p>
            <ul className="links">
                {links?.map((link: any, k: number) => (
                    <li className="link" key={k}>
                        <Link className="link-text" href={link?.link}>
                            {link?.text}
                        </Link>
                    </li>
                ))}
            </ul>
            <p className="desc tip">{t('secJ_tip')}</p>
        </div>
    );
}
